import { createEntityAdapter, createSlice } from '@reduxjs/toolkit';
import { ReduxEntity } from 'Douleutaras/types';
import { RootState } from 'Douleutaras/redux/store';
import { BookNowPatchInfo } from 'Douleutaras/redux/data/v2/crm/types';

const bookNowEntriesAdapter = createEntityAdapter<BookNowPatchInfo>();

export const bookNowEntriesSlice = createSlice({
  name: 'bookNowEntries',
  initialState: bookNowEntriesAdapter.getInitialState({
    entities: [],
    meta: {}
  } as ReduxEntity<BookNowPatchInfo>),
  reducers: {
    bookNowEntryAdd: (state, action) => {
      bookNowEntriesAdapter.upsertOne(state, action.payload);
    }
  },
  extraReducers: () => {}
});

export const bookNowEntriesSelectors = bookNowEntriesAdapter.getSelectors((state: RootState) => state.bookNowEntries);
